<template lang="pug">
div
  q-card-section.q-gutter-md
    .text-h6.row.justify-between
      .col-auto
        q-icon(name="collections").q-px-md
        span Galerie vybraných obrázků
      .col-auto
        q-btn(color="secondary" outline @click="addImage" icon="add") Přidat obrázek
    q-separator
    gallery.q-mt-lg(:images="images" :editable="true" :container-url="attachmentsURL")
      template(v-slot:extra-actions="{image}")
        q-icon.q-px-none.q-mx-none.q-pt-sm(name="remove_red_eye" color="secondary" flat size="xs"
          v-if="image.iiif === (item.thumbnail && item.thumbnail.iiif)")
          q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
            .text-caption Nastaveno jako hlavní obrázek
        q-btn.q-px-none.q-mx-none(icon="remove_red_eye" color="grey-1" flat size="xs"
          @click.stop="starImage(image, true)" :loading="submitting" v-else)
          q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
            .text-caption Nastavit jako hlavní obrázek
</template>

<script>
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { NewRestorationMixin } from '../editor/new-restoration-mixin'
import Gallery from 'components/images/Gallery.vue'
import AddImageDialog from './AddImageDialog.vue'

export default @Component({
  props: {
    collectionCode: String,
    itemId: [String, Number]
  },
  components: {
    'gallery': Gallery
  }
})
class GalleryPage extends mixins(NewRestorationMixin) {
  submitting = false

  mounted () {
    this.$restorationObject.reloadIfNeeded()
  }

  get item () {
    return this.oarepo$.collectionItemModule.item.metadata
  }

  get images () {
    function filterImages (x) {
      return (x._files || [])
    }

    return filterImages(this.item)
  }

  addImage () {
    this.$q.dialog({
      component: AddImageDialog
    }).onOk((response) => {
      this.oarepo$.collectionItemModule.reload()
    })
  }

  get attachmentsURL () {
    return `${this.oarepo$.collectionItemModule.item.links.self}/attachments`
  }

  starImage (image, featuredImage) {
    const imageUrl = `${image._record.links.attachments}/${image.key}`
    this.$axios.post(imageUrl, { featured_image: featuredImage }, {
      headers: [{
        name: 'content-type',
        value: 'application/json'
      }]
    }).then(() => {
      this.oarepo$.collectionItemModule.reload()
    }).catch((err) => {
      this.notify$({ message: `Chyba při aktualizaci obrázku, zkuste prosím ještě jednou: ${err}` })
    })
  }
}
</script>

<style scoped lang="stylus">
.text-tiny
  font-size: xx-small
</style>
